import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'

// Views
import Index from '@/views/Index'
import Ballsaal from '@/views/Ballsaal'
import CoWorking from '@/views/Co-Working'
import Kaffeehaus from '@/views/Kaffeehaus'
import About from '@/views/About'
import Kontakt from '@/views/Kontakt'

// Styles
import styles from '@/assets/scss/main.scss'

// Plugins
import VueMeta from 'vue-meta'
import VueScrollTo from 'vue-scrollto'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueMeta, {
  keyName: 'head'
})
Vue.use(VueScrollTo)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBN9jXIfpYgHECBPiiKPZ-9xelm-ZGwx3s'
  }
})

let routes = [
  { path: '/', name: 'Home', component: Index },
  { path: '/ballsaal', name: 'Ballsaal', component: Ballsaal },
  { path: '/co-working', name: 'Co-Working', component: CoWorking },
  { path: '/kaffeehaus', name: 'Kaffeehaus', component: Kaffeehaus },
  { path: '/hof', name: 'Der Hof', component: About },
  { path: '/kontakt', name: 'Kontakt', component: Kontakt }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

/* eslint-disable no-new */
const vm = new Vue({
  el: '#ctn',
  router,
  template: '<App ref="app"/>',
  ref: 'app',
  style: styles,
  components: { App }
})

// router.onReady(() => {
//   vm.$refs.app.currentIndicator = vm.$refs.app.$refs.page.indicator
//   vm.$refs.app.currentImage = vm.$refs.app.$refs.page.image
// })

// close nav before route
router.beforeEach((to, from, next) => {
  if (document.body.classList.contains('has-nav-open')) {
    // document.body.classList.remove('has-nav-open')
    vm.$refs.app.$refs.header.toggleNav()
    setTimeout(() => {
      next()
    }, 500)
  } else {
    next()
  }
})

router.afterEach(() => {
  // if (!vm.$refs.app.$refs.header.revealHeader) {
  //   // setTimeout(() => {
    // vm.$refs.app.$refs.header.revealHeader = false
  //   // }, 1000)
  // }
})




// WEBPACK FOOTER //
// ./src/main.js